import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import type { DayStats } from '@/types/api.types';

interface DispatchesChartProps {
  data: DayStats[];
}

export function DispatchesChart({ data }: DispatchesChartProps) {
  return (
    <ResponsiveContainer width="100%" height={260}>
      <AreaChart data={data} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
        <defs>
          <linearGradient id="colorSent" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.4} />
            <stop offset="95%" stopColor="#3b82f6" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorDelivered" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#22c55e" stopOpacity={0.4} />
            <stop offset="95%" stopColor="#22c55e" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorRead" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#a855f7" stopOpacity={0.4} />
            <stop offset="95%" stopColor="#a855f7" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorFailed" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#ef4444" stopOpacity={0.4} />
            <stop offset="95%" stopColor="#ef4444" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorPending" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#f59e0b" stopOpacity={0.4} />
            <stop offset="95%" stopColor="#f59e0b" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
        <XAxis
          dataKey="day"
          tick={{ fontSize: 11 }}
          tickFormatter={(v: string) => format(new Date(v), 'dd/MM', { locale: ptBR })}
        />
        <YAxis tick={{ fontSize: 11 }} />
        <Tooltip
          labelFormatter={(v: string) => format(new Date(v), 'dd/MM/yyyy', { locale: ptBR })}
        />
        <Legend iconSize={10} />
        <Area
          type="monotone"
          dataKey="sent"
          name="Enviados"
          stackId="1"
          stroke="#3b82f6"
          fill="url(#colorSent)"
        />
        <Area
          type="monotone"
          dataKey="delivered"
          name="Entregues"
          stackId="1"
          stroke="#22c55e"
          fill="url(#colorDelivered)"
        />
        <Area
          type="monotone"
          dataKey="read"
          name="Lidos"
          stackId="1"
          stroke="#a855f7"
          fill="url(#colorRead)"
        />
        <Area
          type="monotone"
          dataKey="failed"
          name="Falhas"
          stackId="1"
          stroke="#ef4444"
          fill="url(#colorFailed)"
        />
        <Area
          type="monotone"
          dataKey="pending"
          name="Pendentes"
          stackId="1"
          stroke="#f59e0b"
          fill="url(#colorPending)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
